import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { BrowserIdentifier } from '@skylab-shared/utils';
import { $ } from '../utils/element';
import { focusable } from '../utils/focusable';

@Directive({ selector: '[skl-focus-by]' })
export class FocusByDirective {
    @Input('skl-focus-by') public focusBy!: string | null | undefined;
    @Input('skl-focus-by-trigger') public triggerBy!: boolean;

    private readonly isMobile = BrowserIdentifier.isMobile();

    public constructor(
        private readonly elementRef: ElementRef
    ) { }

    public ngOnInit(): void {
        if (!this.triggerBy) {
            this.focusByAction();
        }
    }

    private triggerByFirstChanged = false;
    public ngOnChanges(changes: SimpleChanges) {
        if (this.triggerBy && !this.triggerByFirstChanged && changes['triggerBy'] && changes['triggerBy'].currentValue) {
            this.triggerByFirstChanged = true;
            this.focusByAction();
        }
    }

    public ngOnDestroy(): void {
        clearTimeout(this.focusByActionHandler);
    }

    private getControlToFocus(): {element: HTMLElement, focusMethodName: string} {
        if (this.focusBy) {
            const $focusByElement = $(this.elementRef.nativeElement).find(this.focusBy);
            if ($focusByElement) {
                return focusable($focusByElement.element);
            }
        }
        return focusable(this.elementRef.nativeElement);
    }

    private focusByActionHandler!: ReturnType<typeof setInterval>;

    private focusByAction() {
        clearInterval(this.focusByActionHandler);
        if (this.isMobile) return;

        this.focusByActionHandler = setInterval(() => {
            const control = this.getControlToFocus();
            (control.element as any)?.[control.focusMethodName]?.();

            if (control.element === document.activeElement) {
                clearInterval(this.focusByActionHandler);
            }
        }, 100);
    }
}
